import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        publishedEforms: {
            paginator: {
                rowsByPage: "Resultados por página",
            }
        },
        userActive: {
            cuil: "RUT",
            cuils: "RUT",
        },
        label: {
            dni: "RUT",
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "RUT",
                    question: "¿Cuál es el RUT del colaborador?",
                    description: "Ingresa el RUT del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "RUT",
                },
                dni: "RUT"
            }
        },
        documentDetail: {
            commons: {
                cuil: "RUT",
            }
        }
    }
})